import type { ReactNode } from "react";
import { ChoiceList } from "../../../ui/controls";
import type { LabelledOption } from "./options";
import { FieldError, Helper } from "./parts";

export interface ChoiceFormProps<T extends string> {
  error?: string;
  helper?: ReactNode;
  /** The question; it names the group. */
  label: string;
  onChange: (value: T) => void;
  options: readonly LabelledOption<T>[];
  value: T | null;
}

/**
 * One answer out of a list — A2's `ChoiceSheet` body (editors.tsx:62-105):
 * sex, dominant side, goals, the experience follow-ups, place, occupation,
 * protein, supplement. Controlled; `null` is "not answered yet".
 */
export function ChoiceForm<T extends string>({
  label,
  helper,
  options,
  value,
  onChange,
  error,
}: ChoiceFormProps<T>) {
  return (
    <div>
      {helper ? <Helper>{helper}</Helper> : null}
      <ChoiceList
        label={label}
        onValueChange={onChange}
        options={options}
        value={value}
      />
      {error ? <FieldError>{error}</FieldError> : null}
    </div>
  );
}
